export const getWebchatConfiguration = (clientId = null) => {
  let theConfigs = [
    {
      botId: "4bd1e007-82d6-489b-b750-3cffd26ce32c",
      clientId: "be1af1aa-f1b3-4778-8336-f3cde7c46fa2",
      displayIdentifier: "Mahalo: Search Bot",
      botName: "Banking Support",
      composerPlaceholder: "How can we help?",
      botDescription: "Mahalo AI Assistant",
      title: "Mahalo",
      hostURL: "https://omniscia.ai",
      userData: {
        firstName: "TestFirstName",
        hostURL: "https://omniscia.ai",
        institution: JSON.stringify({
          id: 2,
          name: "Mahalo Credit Union",
          routingNumber: "101050001",
          helpEmail: "help@mahalo.com",
          helpPhoneLocal: "(248) 555-5551",
          helpPhoneTollFree: "(800) 555-1234",
          faxNumber: "(248) 555-5552",
          branding: "Default",
          timeZoneId: "Eastern Standard Time",
          links: [
            {
              id: 1,
              key: "mobile-terms",
              category: "app-links",
              link: "https://google.com",
            },
            {
              id: 2,
              key: "privacy-policy",
              category: "app-links",
              link: "https://google.com",
            },
            {
              id: 3,
              key: "registration",
              category: "app-links",
              link: "https://demo.mahalocloud.org/register?route=mobile",
            },
            {
              id: 4,
              key: "forgot-password",
              category: "app-links",
              link: "https://demo.mahalocloud.org/forgotpassword?route=mobile",
            },
            {
              id: 5,
              key: "ad-link",
              category: "web-links",
              link: "https://cor-web.mahalocloud.org/forgotpassword",
            },
            {
              id: 6,
              key: "join-link",
              category: "web-links",
              link: "https://demo-snmal-web.mahalocloud.org/",
            },
            {
              id: 7,
              key: "main-site",
              category: "web-links",
              link: "https://www.mahalobanking.com",
            },
            {
              id: 8,
              key: "google-store-link",
              category: "web-links",
              link: "https://www.mahalobanking.com",
            },
            {
              id: 9,
              key: "apple-store-link",
              category: "web-links",
              link: "https://www.mahalobanking.com",
            },
            {
              id: 10,
              key: "faq-link",
              category: "web-links",
              link: "https://www.mahalobanking.com",
            },
            {
              id: 11,
              key: "sos",
              category: "web-links",
              link: "https://www.mahalobanking.com",
            },
            {
              id: 12,
              key: "external-account-terms-link",
              category: "web-links",
              link: "https://www.mahalobanking.com",
            },
            {
              id: 13,
              key: "direct-deposit-allocations-link",
              category: "web-links",
              link: "https://www.mahalobanking.com",
            },
            {
              id: 14,
              key: "help-desk-link",
              category: "web-links",
              link: "https://www.mahalobanking.com",
            },
            {
              id: 15,
              key: "master-file-link",
              category: "web-links",
              link: "https://www.mahalobanking.com",
            },
          ],
          branches: [
            {
              id: 1,
              address: "850 Stephenson Hwy",
              extraAddress: "Suite 405",
              city: "Troy",
              state: "MI",
              zipCode: "48083",
              locationNote: null,
              title: "Mahalo Banking",
              phone: "(248) 555-5551",
              fax: "",
              email: "mainbranch@mahalo.com",
              hasLobby: true,
              hasDriveThru: true,
              serviceEntries: [
                {
                  id: 14,
                  branchId: 1,
                  description: "ATM",
                  meta: "Deposits, Check Cashing, Cash Withdrawal",
                },
                {
                  id: 15,
                  branchId: 1,
                  description: "Loans",
                  meta: "Car, Boat, Home, Secured, Line of credit",
                },
                {
                  id: 16,
                  branchId: 1,
                  description: "Instant Issue Debit Cards",
                  meta: "Cards printed in 10 minutes",
                },
                {
                  id: 17,
                  branchId: 1,
                  description: "Notary Public",
                  meta: "Tuesdays and Thursdays only",
                },
              ],
              hoursEntries: [
                {
                  id: 43,
                  branchId: 1,
                  dayOfWeek: "Tuesday",
                  location: "DriveThru",
                  hours: "9:00 am to 5:00 pm EST",
                },
                {
                  id: 44,
                  branchId: 1,
                  dayOfWeek: "Tuesday",
                  location: "Lobby",
                  hours: "9:00 am to 5:00 pm EST",
                },
                {
                  id: 45,
                  branchId: 1,
                  dayOfWeek: "Wednesday",
                  location: "Lobby",
                  hours: "9:00 am to 5:00 pm EST",
                },
                {
                  id: 46,
                  branchId: 1,
                  dayOfWeek: "Thursday",
                  location: "Lobby",
                  hours: "9:00 am to 5:00 pm EST",
                },
                {
                  id: 47,
                  branchId: 1,
                  dayOfWeek: "Friday",
                  location: "Lobby",
                  hours: "9:00 am to 5:00 pm EST",
                },
                {
                  id: 48,
                  branchId: 1,
                  dayOfWeek: "Saturday",
                  location: "Lobby",
                  hours: "Closed",
                },
                {
                  id: 49,
                  branchId: 1,
                  dayOfWeek: "Sunday",
                  location: "DriveThru",
                  hours: "Closed",
                },
                {
                  id: 50,
                  branchId: 1,
                  dayOfWeek: "Monday",
                  location: "DriveThru",
                  hours: "9:00 am to 5:00 pm EST",
                },
                {
                  id: 51,
                  branchId: 1,
                  dayOfWeek: "Monday",
                  location: "Lobby",
                  hours: "9:00 am to 5:00 pm EST",
                },
                {
                  id: 52,
                  branchId: 1,
                  dayOfWeek: "Sunday",
                  location: "Lobby",
                  hours: "Closed",
                },
                {
                  id: 53,
                  branchId: 1,
                  dayOfWeek: "Thursday",
                  location: "DriveThru",
                  hours: "9:00 am to 5:00 pm EST",
                },
                {
                  id: 54,
                  branchId: 1,
                  dayOfWeek: "Friday",
                  location: "DriveThru",
                  hours: "9:00 am to 5:00 pm EST",
                },
                {
                  id: 55,
                  branchId: 1,
                  dayOfWeek: "Saturday",
                  location: "DriveThru",
                  hours: "Closed",
                },
                {
                  id: 56,
                  branchId: 1,
                  dayOfWeek: "Wednesday",
                  location: "DriveThru",
                  hours: "9:00 am to 5:00 pm EST",
                },
              ],
              branchLinks: [],
            },
            {
              id: 2,
              address: "12345 Fast Lane Hwy",
              extraAddress: null,
              city: "Detroit",
              state: "MI",
              zipCode: "48083",
              locationNote: null,
              title: "Secondary Detroit Branch",
              phone: "(248) 555-5551",
              fax: "",
              email: "secondarybranch@mahalo.com",
              hasLobby: true,
              hasDriveThru: true,
              serviceEntries: [
                {
                  id: 8,
                  branchId: 2,
                  description: "ATM",
                  meta: "Deposits, Check Cashing, Cash Withdrawal",
                },
                {
                  id: 9,
                  branchId: 2,
                  description: "Notary Public",
                  meta: "Tuesdays and Thursdays only",
                },
                {
                  id: 10,
                  branchId: 2,
                  description: "Instant Issue Debit Cards",
                  meta: "Cards printed in 10 minutes",
                },
                {
                  id: 11,
                  branchId: 2,
                  description: "Loans",
                  meta: "Car, Boat, Home, Secured, Line of credit",
                },
              ],
              hoursEntries: [
                {
                  id: 2,
                  branchId: 2,
                  dayOfWeek: "Monday",
                  location: "DriveThru",
                  hours: "9:00 am to 5:00 pm EST",
                },
                {
                  id: 3,
                  branchId: 2,
                  dayOfWeek: "Tuesday",
                  location: "DriveThru",
                  hours: "9:00 am to 5:00 pm EST",
                },
                {
                  id: 4,
                  branchId: 2,
                  dayOfWeek: "Thursday",
                  location: "DriveThru",
                  hours: "9:00 am to 5:00 pm EST",
                },
                {
                  id: 5,
                  branchId: 2,
                  dayOfWeek: "Friday",
                  location: "DriveThru",
                  hours: "9:00 am to 5:00 pm EST",
                },
                {
                  id: 6,
                  branchId: 2,
                  dayOfWeek: "Saturday",
                  location: "DriveThru",
                  hours: "Closed",
                },
                {
                  id: 7,
                  branchId: 2,
                  dayOfWeek: "Sunday",
                  location: "DriveThru",
                  hours: "Closed",
                },
                {
                  id: 11,
                  branchId: 2,
                  dayOfWeek: "Sunday",
                  location: "Lobby",
                  hours: "Closed",
                },
                {
                  id: 23,
                  branchId: 2,
                  dayOfWeek: "Saturday",
                  location: "Lobby",
                  hours: "Closed",
                },
                {
                  id: 24,
                  branchId: 2,
                  dayOfWeek: "Wednesday",
                  location: "DriveThru",
                  hours: "9:00 am to 5:00 pm EST",
                },
                {
                  id: 25,
                  branchId: 2,
                  dayOfWeek: "Thursday",
                  location: "Lobby",
                  hours: "9:00 am to 5:00 pm EST",
                },
                {
                  id: 36,
                  branchId: 2,
                  dayOfWeek: "Friday",
                  location: "Lobby",
                  hours: "9:00 am to 5:00 pm EST",
                },
                {
                  id: 39,
                  branchId: 2,
                  dayOfWeek: "Wednesday",
                  location: "Lobby",
                  hours: "9:00 am to 5:00 pm EST",
                },
                {
                  id: 40,
                  branchId: 2,
                  dayOfWeek: "Tuesday",
                  location: "Lobby",
                  hours: "9:00 am to 5:00 pm EST",
                },
                {
                  id: 41,
                  branchId: 2,
                  dayOfWeek: "Monday",
                  location: "Lobby",
                  hours: "9:00 am to 5:00 pm EST",
                },
              ],
              branchLinks: [],
            },
            {
              id: 3,
              address: "12345 Fast Lane Hwy",
              extraAddress: "Suite C",
              city: "Detroit",
              state: "MI",
              zipCode: "48083",
              locationNote: "Located by Mardigian Library",
              title: "Third Detroit Branch",
              phone: "(248) 555-5551",
              fax: "",
              email: "thirdbranch@mahalo.com",
              hasLobby: true,
              hasDriveThru: false,
              serviceEntries: [
                {
                  id: 6,
                  branchId: 3,
                  description: "Student Loans",
                  meta: "New or Consolidation loans",
                },
                {
                  id: 7,
                  branchId: 3,
                  description: "ATM",
                  meta: "Deposits, Check Cashing, Cash Withdrawal",
                },
              ],
              hoursEntries: [
                {
                  id: 8,
                  branchId: 3,
                  dayOfWeek: "Monday",
                  location: "Lobby",
                  hours: "8:00 am to 7:30 pm EST",
                },
                {
                  id: 9,
                  branchId: 3,
                  dayOfWeek: "Tuesday",
                  location: "Lobby",
                  hours: "8:00 am to 7:30 pm EST",
                },
                {
                  id: 10,
                  branchId: 3,
                  dayOfWeek: "Wednesday",
                  location: "Lobby",
                  hours: "8:00 am to 7:30 pm EST",
                },
                {
                  id: 12,
                  branchId: 3,
                  dayOfWeek: "Thursday",
                  location: "Lobby",
                  hours: "8:00 am to 7:30 pm EST",
                },
                {
                  id: 13,
                  branchId: 3,
                  dayOfWeek: "Saturday",
                  location: "Lobby",
                  hours: "8:00 am to 11:00 am EST",
                },
                {
                  id: 14,
                  branchId: 3,
                  dayOfWeek: "Sunday",
                  location: "Lobby",
                  hours: "8:00 am to 11:00 am EST",
                },
                {
                  id: 22,
                  branchId: 3,
                  dayOfWeek: "Friday",
                  location: "Lobby",
                  hours: "8:00 am to 7:30 pm EST",
                },
              ],
              branchLinks: [],
            },
            {
              id: 4,
              address: "12345 Fast Lane Hwy",
              extraAddress: "",
              city: "Detroit",
              state: "MI",
              zipCode: "48083",
              locationNote: "2nd Floor, Dunbar building. Southwest campus",
              title: "Fourth Detroit Branch",
              phone: "(248) 555-5551",
              fax: "",
              email: "fourthbranch@mahalo.com",
              hasLobby: true,
              hasDriveThru: false,
              serviceEntries: [
                {
                  id: 2,
                  branchId: 4,
                  description: "Instant Issue Debit Cards",
                  meta: "Cards printed in 10 minutes",
                },
                {
                  id: 3,
                  branchId: 4,
                  description: "Student Loans",
                  meta: "New or Consolidation loans",
                },
                {
                  id: 13,
                  branchId: 4,
                  description: "Financial Advisor",
                  meta: "Free Consultation, no commitment",
                },
              ],
              hoursEntries: [
                {
                  id: 15,
                  branchId: 4,
                  dayOfWeek: "Monday",
                  location: "Lobby",
                  hours: "8:00 am to 7:30 pm EST",
                },
                {
                  id: 16,
                  branchId: 4,
                  dayOfWeek: "Tuesday",
                  location: "Lobby",
                  hours: "8:00 am to 7:30 pm EST",
                },
                {
                  id: 17,
                  branchId: 4,
                  dayOfWeek: "Wednesday",
                  location: "Lobby",
                  hours: "8:00 am to 7:30 pm EST",
                },
                {
                  id: 18,
                  branchId: 4,
                  dayOfWeek: "Thursday",
                  location: "Lobby",
                  hours: "8:00 am to 7:30 pm EST",
                },
                {
                  id: 19,
                  branchId: 4,
                  dayOfWeek: "Friday",
                  location: "Lobby",
                  hours: "8:00 am to 7:30 pm EST",
                },
                {
                  id: 20,
                  branchId: 4,
                  dayOfWeek: "Saturday",
                  location: "Lobby",
                  hours: "8:00 am to 11:00 am EST",
                },
                {
                  id: 21,
                  branchId: 4,
                  dayOfWeek: "Sunday",
                  location: "Lobby",
                  hours: "8:00 am to 11:00 am EST",
                },
              ],
              branchLinks: [],
            },
          ],
          holidaySettings: {
            holidays: [
              {
                id: 1,
                description: "New Year's Day",
                holidayDate: "2020-01-01T00:00:00+00:00",
              },
              {
                id: 2,
                description: "New Year's Day",
                holidayDate: "2021-01-01T00:00:00+00:00",
              },
              {
                id: 3,
                description: "New Year's Day",
                holidayDate: "2021-12-31T00:00:00+00:00",
              },
              {
                id: 4,
                description: "New Year's Day",
                holidayDate: "2023-01-02T00:00:00+00:00",
              },
              {
                id: 5,
                description: "New Year's Day",
                holidayDate: "2024-01-01T00:00:00+00:00",
              },
              {
                id: 6,
                description: "New Year's Day",
                holidayDate: "2025-01-01T00:00:00+00:00",
              },
              {
                id: 7,
                description: "New Year's Day",
                holidayDate: "2026-01-01T00:00:00+00:00",
              },
              {
                id: 8,
                description: "New Year's Day",
                holidayDate: "2027-01-01T00:00:00+00:00",
              },
              {
                id: 9,
                description: "New Year's Day",
                holidayDate: "2027-12-31T00:00:00+00:00",
              },
              {
                id: 10,
                description: "New Year's Day",
                holidayDate: "2029-01-01T00:00:00+00:00",
              },
              {
                id: 11,
                description: "New Year's Day",
                holidayDate: "2030-01-01T00:00:00+00:00",
              },
              {
                id: 12,
                description: "Martin Luther King Jr. Day",
                holidayDate: "2020-01-20T00:00:00+00:00",
              },
              {
                id: 13,
                description: "Martin Luther King Jr. Day",
                holidayDate: "2021-01-18T00:00:00+00:00",
              },
              {
                id: 14,
                description: "Martin Luther King Jr. Day",
                holidayDate: "2022-01-17T00:00:00+00:00",
              },
              {
                id: 15,
                description: "Martin Luther King Jr. Day",
                holidayDate: "2023-01-16T00:00:00+00:00",
              },
              {
                id: 16,
                description: "Martin Luther King Jr. Day",
                holidayDate: "2024-01-15T00:00:00+00:00",
              },
              {
                id: 17,
                description: "Martin Luther King Jr. Day",
                holidayDate: "2025-01-20T00:00:00+00:00",
              },
              {
                id: 18,
                description: "Martin Luther King Jr. Day",
                holidayDate: "2026-01-19T00:00:00+00:00",
              },
              {
                id: 19,
                description: "Martin Luther King Jr. Day",
                holidayDate: "2027-01-18T00:00:00+00:00",
              },
              {
                id: 20,
                description: "Martin Luther King Jr. Day",
                holidayDate: "2028-01-17T00:00:00+00:00",
              },
              {
                id: 21,
                description: "Martin Luther King Jr. Day",
                holidayDate: "2029-01-15T00:00:00+00:00",
              },
              {
                id: 22,
                description: "Martin Luther King Jr. Day",
                holidayDate: "2030-01-21T00:00:00+00:00",
              },
              {
                id: 23,
                description: "Presidents' Day",
                holidayDate: "2020-02-17T00:00:00+00:00",
              },
              {
                id: 24,
                description: "Presidents' Day",
                holidayDate: "2021-02-15T00:00:00+00:00",
              },
              {
                id: 25,
                description: "Presidents' Day",
                holidayDate: "2022-02-21T00:00:00+00:00",
              },
              {
                id: 26,
                description: "Presidents' Day",
                holidayDate: "2023-02-20T00:00:00+00:00",
              },
              {
                id: 27,
                description: "Presidents' Day",
                holidayDate: "2024-02-19T00:00:00+00:00",
              },
              {
                id: 28,
                description: "Presidents' Day",
                holidayDate: "2025-02-17T00:00:00+00:00",
              },
              {
                id: 29,
                description: "Presidents' Day",
                holidayDate: "2026-02-16T00:00:00+00:00",
              },
              {
                id: 30,
                description: "Presidents' Day",
                holidayDate: "2027-02-15T00:00:00+00:00",
              },
              {
                id: 31,
                description: "Presidents' Day",
                holidayDate: "2028-02-21T00:00:00+00:00",
              },
              {
                id: 32,
                description: "Presidents' Day",
                holidayDate: "2029-02-19T00:00:00+00:00",
              },
              {
                id: 33,
                description: "Presidents' Day",
                holidayDate: "2030-02-18T00:00:00+00:00",
              },
              {
                id: 34,
                description: "Memorial Day",
                holidayDate: "2020-05-25T00:00:00+00:00",
              },
              {
                id: 35,
                description: "Memorial Day",
                holidayDate: "2021-05-31T00:00:00+00:00",
              },
              {
                id: 36,
                description: "Memorial Day",
                holidayDate: "2022-05-30T00:00:00+00:00",
              },
              {
                id: 37,
                description: "Memorial Day",
                holidayDate: "2023-05-29T00:00:00+00:00",
              },
              {
                id: 38,
                description: "Memorial Day",
                holidayDate: "2024-05-27T00:00:00+00:00",
              },
              {
                id: 39,
                description: "Memorial Day",
                holidayDate: "2025-05-26T00:00:00+00:00",
              },
              {
                id: 40,
                description: "Memorial Day",
                holidayDate: "2026-05-25T00:00:00+00:00",
              },
              {
                id: 41,
                description: "Memorial Day",
                holidayDate: "2027-05-31T00:00:00+00:00",
              },
              {
                id: 42,
                description: "Memorial Day",
                holidayDate: "2028-05-29T00:00:00+00:00",
              },
              {
                id: 43,
                description: "Memorial Day",
                holidayDate: "2029-05-28T00:00:00+00:00",
              },
              {
                id: 44,
                description: "Memorial Day",
                holidayDate: "2030-05-27T00:00:00+00:00",
              },
              {
                id: 45,
                description: "Independence Day",
                holidayDate: "2020-07-03T00:00:00+00:00",
              },
              {
                id: 46,
                description: "Independence Day",
                holidayDate: "2021-07-05T00:00:00+00:00",
              },
              {
                id: 47,
                description: "Independence Day",
                holidayDate: "2022-07-04T00:00:00+00:00",
              },
              {
                id: 48,
                description: "Independence Day",
                holidayDate: "2023-07-04T00:00:00+00:00",
              },
              {
                id: 49,
                description: "Independence Day",
                holidayDate: "2024-07-04T00:00:00+00:00",
              },
              {
                id: 50,
                description: "Independence Day",
                holidayDate: "2025-07-04T00:00:00+00:00",
              },
              {
                id: 51,
                description: "Independence Day",
                holidayDate: "2026-07-03T00:00:00+00:00",
              },
              {
                id: 52,
                description: "Independence Day",
                holidayDate: "2027-07-05T00:00:00+00:00",
              },
              {
                id: 53,
                description: "Independence Day",
                holidayDate: "2028-07-04T00:00:00+00:00",
              },
              {
                id: 54,
                description: "Independence Day",
                holidayDate: "2029-07-04T00:00:00+00:00",
              },
              {
                id: 55,
                description: "Independence Day",
                holidayDate: "2030-07-04T00:00:00+00:00",
              },
              {
                id: 56,
                description: "Labor Day",
                holidayDate: "2020-09-07T00:00:00+00:00",
              },
              {
                id: 57,
                description: "Labor Day",
                holidayDate: "2021-09-06T00:00:00+00:00",
              },
              {
                id: 58,
                description: "Labor Day",
                holidayDate: "2022-09-05T00:00:00+00:00",
              },
              {
                id: 59,
                description: "Labor Day",
                holidayDate: "2023-09-04T00:00:00+00:00",
              },
              {
                id: 60,
                description: "Labor Day",
                holidayDate: "2024-09-02T00:00:00+00:00",
              },
              {
                id: 61,
                description: "Labor Day",
                holidayDate: "2025-09-01T00:00:00+00:00",
              },
              {
                id: 62,
                description: "Labor Day",
                holidayDate: "2026-09-07T00:00:00+00:00",
              },
              {
                id: 63,
                description: "Labor Day",
                holidayDate: "2027-09-06T00:00:00+00:00",
              },
              {
                id: 64,
                description: "Labor Day",
                holidayDate: "2028-09-04T00:00:00+00:00",
              },
              {
                id: 65,
                description: "Labor Day",
                holidayDate: "2029-09-03T00:00:00+00:00",
              },
              {
                id: 66,
                description: "Labor Day",
                holidayDate: "2030-09-02T00:00:00+00:00",
              },
              {
                id: 67,
                description: "Columbus Day",
                holidayDate: "2020-10-12T00:00:00+00:00",
              },
              {
                id: 68,
                description: "Columbus Day",
                holidayDate: "2021-10-11T00:00:00+00:00",
              },
              {
                id: 69,
                description: "Columbus Day",
                holidayDate: "2022-10-10T00:00:00+00:00",
              },
              {
                id: 70,
                description: "Columbus Day",
                holidayDate: "2023-10-09T00:00:00+00:00",
              },
              {
                id: 71,
                description: "Columbus Day",
                holidayDate: "2024-10-14T00:00:00+00:00",
              },
              {
                id: 72,
                description: "Columbus Day",
                holidayDate: "2025-10-13T00:00:00+00:00",
              },
              {
                id: 73,
                description: "Columbus Day",
                holidayDate: "2026-10-12T00:00:00+00:00",
              },
              {
                id: 74,
                description: "Columbus Day",
                holidayDate: "2027-10-11T00:00:00+00:00",
              },
              {
                id: 75,
                description: "Columbus Day",
                holidayDate: "2028-10-09T00:00:00+00:00",
              },
              {
                id: 76,
                description: "Columbus Day",
                holidayDate: "2029-10-08T00:00:00+00:00",
              },
              {
                id: 77,
                description: "Columbus Day",
                holidayDate: "2030-10-14T00:00:00+00:00",
              },
              {
                id: 78,
                description: "Veterans Day",
                holidayDate: "2020-11-11T00:00:00+00:00",
              },
              {
                id: 79,
                description: "Veterans Day",
                holidayDate: "2021-11-11T00:00:00+00:00",
              },
              {
                id: 80,
                description: "Veterans Day",
                holidayDate: "2022-11-11T00:00:00+00:00",
              },
              {
                id: 81,
                description: "Veterans Day",
                holidayDate: "2023-11-10T00:00:00+00:00",
              },
              {
                id: 82,
                description: "Veterans Day",
                holidayDate: "2024-11-11T00:00:00+00:00",
              },
              {
                id: 83,
                description: "Veterans Day",
                holidayDate: "2025-11-11T00:00:00+00:00",
              },
              {
                id: 84,
                description: "Veterans Day",
                holidayDate: "2026-11-11T00:00:00+00:00",
              },
              {
                id: 85,
                description: "Veterans Day",
                holidayDate: "2027-11-11T00:00:00+00:00",
              },
              {
                id: 86,
                description: "Veterans Day",
                holidayDate: "2028-11-10T00:00:00+00:00",
              },
              {
                id: 87,
                description: "Veterans Day",
                holidayDate: "2029-11-12T00:00:00+00:00",
              },
              {
                id: 88,
                description: "Veterans Day",
                holidayDate: "2030-11-11T00:00:00+00:00",
              },
              {
                id: 89,
                description: "Thanksgiving Day",
                holidayDate: "2020-11-26T00:00:00+00:00",
              },
              {
                id: 90,
                description: "Thanksgiving Day",
                holidayDate: "2021-11-25T00:00:00+00:00",
              },
              {
                id: 91,
                description: "Thanksgiving Day",
                holidayDate: "2022-11-24T00:00:00+00:00",
              },
              {
                id: 92,
                description: "Thanksgiving Day",
                holidayDate: "2023-11-23T00:00:00+00:00",
              },
              {
                id: 93,
                description: "Thanksgiving Day",
                holidayDate: "2024-11-28T00:00:00+00:00",
              },
              {
                id: 94,
                description: "Thanksgiving Day",
                holidayDate: "2025-11-27T00:00:00+00:00",
              },
              {
                id: 95,
                description: "Thanksgiving Day",
                holidayDate: "2026-11-26T00:00:00+00:00",
              },
              {
                id: 96,
                description: "Thanksgiving Day",
                holidayDate: "2027-11-25T00:00:00+00:00",
              },
              {
                id: 97,
                description: "Thanksgiving Day",
                holidayDate: "2028-11-23T00:00:00+00:00",
              },
              {
                id: 98,
                description: "Thanksgiving Day",
                holidayDate: "2029-11-22T00:00:00+00:00",
              },
              {
                id: 99,
                description: "Thanksgiving Day",
                holidayDate: "2030-11-28T00:00:00+00:00",
              },
              {
                id: 100,
                description: "Christmas Day",
                holidayDate: "2020-12-25T00:00:00+00:00",
              },
              {
                id: 101,
                description: "Christmas Day",
                holidayDate: "2021-12-24T00:00:00+00:00",
              },
              {
                id: 102,
                description: "Christmas Day",
                holidayDate: "2022-12-26T00:00:00+00:00",
              },
              {
                id: 103,
                description: "Christmas Day",
                holidayDate: "2023-12-25T00:00:00+00:00",
              },
              {
                id: 104,
                description: "Christmas Day",
                holidayDate: "2024-12-25T00:00:00+00:00",
              },
              {
                id: 105,
                description: "Christmas Day",
                holidayDate: "2025-12-25T00:00:00+00:00",
              },
              {
                id: 106,
                description: "Christmas Day",
                holidayDate: "2026-12-25T00:00:00+00:00",
              },
              {
                id: 107,
                description: "Christmas Day",
                holidayDate: "2027-12-24T00:00:00+00:00",
              },
              {
                id: 108,
                description: "Christmas Day",
                holidayDate: "2028-12-25T00:00:00+00:00",
              },
              {
                id: 109,
                description: "Christmas Day",
                holidayDate: "2029-12-25T00:00:00+00:00",
              },
              {
                id: 110,
                description: "Christmas Day",
                holidayDate: "2030-12-25T00:00:00+00:00",
              },
              {
                id: 111,
                description: "Juneteenth",
                holidayDate: "2024-06-19T00:00:00+00:00",
              },
              {
                id: 112,
                description: "Juneteenth",
                holidayDate: "2025-06-19T00:00:00+00:00",
              },
              {
                id: 113,
                description: "Juneteenth",
                holidayDate: "2026-06-19T00:00:00+00:00",
              },
              {
                id: 114,
                description: "Juneteenth",
                holidayDate: "2027-06-18T00:00:00+00:00",
              },
              {
                id: 115,
                description: "Juneteenth",
                holidayDate: "2028-06-19T00:00:00+00:00",
              },
              {
                id: 116,
                description: "Juneteenth",
                holidayDate: "2029-06-19T00:00:00+00:00",
              },
              {
                id: 117,
                description: "Juneteenth",
                holidayDate: "2030-06-19T00:00:00+00:00",
              },
            ],
          },
          contactNumbers: [],
          createAtUtc: "2023-07-11T14:01:47.8310461+00:00",
          changeAtUtc: "2025-06-25T16:00:26.7517401+00:00",
        }),
      },
    },
    {
      botId: "890e9bb6-b2c1-4a3d-ae81-c967f3c8c70f",
      clientId: "1d9c1910-60da-4fa2-a237-89fd3122b711",
      displayIdentifier: "DEMO - Isa Bot",
      botName: "Isabella Echeverri",
      composerPlaceholder: "Let's talk women's soccer",
      botDescription: "Human Emulation Avatar",
      title: "Isabella Echeverri",
      userData: { firstName: "TestFirstName" },
    },
    {
      botId: "ff935ea6-cadf-4e87-90cf-8cc9af1b2538",
      clientId: "a4a35bff-1445-4a94-a544-928b4a38c8aa",
      displayIdentifier: "Park View Federal CU: Penny",
      botName: "Penny",
      composerPlaceholder: "Ask your question here",
      botDescription: "A Financial AI Assistant",
      title: "Park View Federal Credit Union",
      userData: { firstName: "TestFirstName", languageCode: "en-us" },
    },
    {
      botId: "2dc49223-fc6b-4308-af8c-fdf15a1ca74e",
      clientId: "a53fb74e-6eeb-4bfb-8af8-d7097ef662ef",
      displayIdentifier: "Demo - Walmart Associate Assistant",
      botName: "Walmart AI Assistant",
      composerPlaceholder: "",
      botDescription: `I can assist you with information and guidance related to Walmart outreach and philanthropic initiatives. Let me help you learn more about our programs and resources.`,
      title: "Walmart AI Assistant",
      userData: { firstName: "TestFirstName", languageCode: "en-us" },
    },
    {
      botId: "03aeb9ee-261e-4471-84b3-b921b6e90482",
      clientId: "387060e7-5d49-4fdf-b140-2bbd1b5dfd88",
      displayIdentifier: "Visions",
      botName: "Visions",
      composerPlaceholder: "How can we help you today?",
      botDescription: "Visions AI Assistant",
      title: "Visions",
      userData: { firstName: "TestName", languageCode: "en-us" },
    },
  ];

  if (clientId != null) {
    let filtered = theConfigs.filter(obj => obj.clientId === clientId);
    if (filtered.length > 0) {
      return filtered[0];
    } else {
      return null;
    }
  } else {
    return theConfigs;
  }
};

//OLD, Depricated, use getWebchatConfiguration instead
export const getConfiguration = (clientId = null) => {
  let theConfigs = [
    {
      clientId: "ee055c13-c543-48ba-af60-0f7984d969b1",
      languageCodes: [{ name: "English (US)", languageCode: "en-us" }],
      userData: { firstName: "TestName", languageCode: "en-us" },
      displayIdentifier: "Hyperbaric Wellness: Site Bot",
      harnessFolder: "",
      botId: "guid",
      botName: "Craig 2000",
      botAvatar: `${
        window.location.origin.includes("localhost")
          ? `https://dev.omnisciahealth.coach`
          : window.location.origin
      }/assets/images/drCraig.jpeg`,
      composerPlaceholder: "Have any questions?",
      botDescription: "Get answers to all of your Long COVID questions.",
      title: "Learn about COVID",
    },
    {
      clientId: "707d58dd-fe80-4fc4-bb8f-6e82c851bdcd",
      languageCodes: [{ name: "English (US)", languageCode: "en-us" }],
      userData: { firstName: "TestName", languageCode: "en-us" },
      displayIdentifier: "Omni: Imposter Bot ",
      harnessFolder: "",
      botId: "guid",
      botName: "Imposter Bot",
      composerPlaceholder: "What's on your mind?",
      botDescription: "A celebrity friend.",
      title: "Imposter Bot",
    },
    {
      clientId: "ce635d54-d891-49b4-b2da-9150712cc43d",
      languageCodes: [{ name: "English (US)", languageCode: "en-us" }],
      userData: { firstName: "TestName", languageCode: "en-us" },
      displayIdentifier: "Omni: USL",
      harnessFolder: "",
      botId: "guid",
      botName: "USL Spokane",
      composerPlaceholder: "Have any questions?",
      botDescription: "Get answers to all of your Zephyr Soccer Questions.",
      title: "Learn about USL Spokane",
    },
    {
      clientId: "c1ea175b-aa10-482b-8020-29dab0dc293a",
      languageCodes: [{ name: "English (US)", languageCode: "en-us" }],
      userData: { firstName: "TestName", languageCode: "en-us" },
      displayIdentifier: "Omni: Zephyr",
      harnessFolder: "",
      botId: "guid",
      botName: "Zephyr",
      composerPlaceholder: "Have any questions?",
      botDescription: "Get answers to all of your Zephyr Soccer Questions.",
      title: "Zephyr Fan Info",
    },
    {
      clientId: "665f896a-04cd-43ac-a955-8ff7a2836c12",
      languageCodes: [{ name: "English (US)", languageCode: "en-us" }],
      userData: { firstName: "TestName", languageCode: "en-us" },
      displayIdentifier: "MAPSCU: Assistant",
      harnessFolder: "",
      botId: "guid",
      botName: "MAPSCU",
      composerPlaceholder: "What can MAPSCU do for you?",
      botDescription: "MAPSCU A.I. Assistant",
      title: "MAPSCU",
    },
    {
      clientId: "11cd087f-86b7-4f6b-824e-2729dffd3aa4",
      languageCodes: [{ name: "English (US)", languageCode: "en-us" }],
      userData: { firstName: "TestName", languageCode: "en-us" },
      displayIdentifier: "Kindly Human: search",
      harnessFolder: "",
      botId: "guid",
      botName: "Kindly Human",
      composerPlaceholder: "What's on your mind?",
      botDescription: "AI Confidant",
      title: "Kindly Human",
    },
    {
      clientId: "be1af1aa-f1b3-4778-8336-f3cde7c46fa2",
      languageCodes: [
        { name: "English (US)", languageCode: "en-us" },
        { name: "Spanish (US)", languageCode: "es-us" },
      ],
      userData: {
        firstName: "TestName",
        languageCode: "en-us",
        institution: JSON.stringify({
          id: 2,
          name: "Mahalo Credit Union",
          routingNumber: "101050001",
          helpEmail: "help@mahalo.com",
          helpPhoneLocal: "(248) 555-5551",
          helpPhoneTollFree: "(800) 555-1234",
          faxNumber: "(248) 555-5552",
          branding: "Default",
          timeZoneId: "Eastern Standard Time",
          links: [
            {
              id: 1,
              key: "mobile-terms",
              category: "app-links",
              link: "https://google.com",
            },
            {
              id: 2,
              key: "privacy-policy",
              category: "app-links",
              link: "https://google.com",
            },
            {
              id: 3,
              key: "registration",
              category: "app-links",
              link: "https://demo.mahalocloud.org/register?route=mobile",
            },
            {
              id: 4,
              key: "forgot-password",
              category: "app-links",
              link: "https://demo.mahalocloud.org/forgotpassword?route=mobile",
            },
            {
              id: 5,
              key: "ad-link",
              category: "web-links",
              link: "https://cor-web.mahalocloud.org/forgotpassword",
            },
            {
              id: 6,
              key: "join-link",
              category: "web-links",
              link: "https://demo-snmal-web.mahalocloud.org/",
            },
            {
              id: 7,
              key: "main-site",
              category: "web-links",
              link: "https://www.mahalobanking.com",
            },
            {
              id: 8,
              key: "google-store-link",
              category: "web-links",
              link: "https://www.mahalobanking.com",
            },
            {
              id: 9,
              key: "apple-store-link",
              category: "web-links",
              link: "https://www.mahalobanking.com",
            },
            {
              id: 10,
              key: "faq-link",
              category: "web-links",
              link: "https://www.mahalobanking.com",
            },
            {
              id: 11,
              key: "sos",
              category: "web-links",
              link: "https://www.mahalobanking.com",
            },
            {
              id: 12,
              key: "external-account-terms-link",
              category: "web-links",
              link: "https://www.mahalobanking.com",
            },
            {
              id: 13,
              key: "direct-deposit-allocations-link",
              category: "web-links",
              link: "https://www.mahalobanking.com",
            },
            {
              id: 14,
              key: "help-desk-link",
              category: "web-links",
              link: "https://www.mahalobanking.com",
            },
            {
              id: 15,
              key: "master-file-link",
              category: "web-links",
              link: "https://www.mahalobanking.com",
            },
          ],
          branches: [
            {
              id: 1,
              address: "850 Stephenson Hwy",
              extraAddress: "Suite 405",
              city: "Troy",
              state: "MI",
              zipCode: "48083",
              locationNote: null,
              title: "Mahalo Banking",
              phone: "(248) 555-5551",
              fax: "",
              email: "mainbranch@mahalo.com",
              hasLobby: true,
              hasDriveThru: true,
              serviceEntries: [
                {
                  id: 14,
                  branchId: 1,
                  description: "ATM",
                  meta: "Deposits, Check Cashing, Cash Withdrawal",
                },
                {
                  id: 15,
                  branchId: 1,
                  description: "Loans",
                  meta: "Car, Boat, Home, Secured, Line of credit",
                },
                {
                  id: 16,
                  branchId: 1,
                  description: "Instant Issue Debit Cards",
                  meta: "Cards printed in 10 minutes",
                },
                {
                  id: 17,
                  branchId: 1,
                  description: "Notary Public",
                  meta: "Tuesdays and Thursdays only",
                },
              ],
              hoursEntries: [
                {
                  id: 43,
                  branchId: 1,
                  dayOfWeek: "Tuesday",
                  location: "DriveThru",
                  hours: "9:00 am to 5:00 pm EST",
                },
                {
                  id: 44,
                  branchId: 1,
                  dayOfWeek: "Tuesday",
                  location: "Lobby",
                  hours: "9:00 am to 5:00 pm EST",
                },
                {
                  id: 45,
                  branchId: 1,
                  dayOfWeek: "Wednesday",
                  location: "Lobby",
                  hours: "9:00 am to 5:00 pm EST",
                },
                {
                  id: 46,
                  branchId: 1,
                  dayOfWeek: "Thursday",
                  location: "Lobby",
                  hours: "9:00 am to 5:00 pm EST",
                },
                {
                  id: 47,
                  branchId: 1,
                  dayOfWeek: "Friday",
                  location: "Lobby",
                  hours: "9:00 am to 5:00 pm EST",
                },
                {
                  id: 48,
                  branchId: 1,
                  dayOfWeek: "Saturday",
                  location: "Lobby",
                  hours: "Closed",
                },
                {
                  id: 49,
                  branchId: 1,
                  dayOfWeek: "Sunday",
                  location: "DriveThru",
                  hours: "Closed",
                },
                {
                  id: 50,
                  branchId: 1,
                  dayOfWeek: "Monday",
                  location: "DriveThru",
                  hours: "9:00 am to 5:00 pm EST",
                },
                {
                  id: 51,
                  branchId: 1,
                  dayOfWeek: "Monday",
                  location: "Lobby",
                  hours: "9:00 am to 5:00 pm EST",
                },
                {
                  id: 52,
                  branchId: 1,
                  dayOfWeek: "Sunday",
                  location: "Lobby",
                  hours: "Closed",
                },
                {
                  id: 53,
                  branchId: 1,
                  dayOfWeek: "Thursday",
                  location: "DriveThru",
                  hours: "9:00 am to 5:00 pm EST",
                },
                {
                  id: 54,
                  branchId: 1,
                  dayOfWeek: "Friday",
                  location: "DriveThru",
                  hours: "9:00 am to 5:00 pm EST",
                },
                {
                  id: 55,
                  branchId: 1,
                  dayOfWeek: "Saturday",
                  location: "DriveThru",
                  hours: "Closed",
                },
                {
                  id: 56,
                  branchId: 1,
                  dayOfWeek: "Wednesday",
                  location: "DriveThru",
                  hours: "9:00 am to 5:00 pm EST",
                },
              ],
              branchLinks: [],
            },
            {
              id: 2,
              address: "12345 Fast Lane Hwy",
              extraAddress: null,
              city: "Detroit",
              state: "MI",
              zipCode: "48083",
              locationNote: null,
              title: "Secondary Detroit Branch",
              phone: "(248) 555-5551",
              fax: "",
              email: "secondarybranch@mahalo.com",
              hasLobby: true,
              hasDriveThru: true,
              serviceEntries: [
                {
                  id: 8,
                  branchId: 2,
                  description: "ATM",
                  meta: "Deposits, Check Cashing, Cash Withdrawal",
                },
                {
                  id: 9,
                  branchId: 2,
                  description: "Notary Public",
                  meta: "Tuesdays and Thursdays only",
                },
                {
                  id: 10,
                  branchId: 2,
                  description: "Instant Issue Debit Cards",
                  meta: "Cards printed in 10 minutes",
                },
                {
                  id: 11,
                  branchId: 2,
                  description: "Loans",
                  meta: "Car, Boat, Home, Secured, Line of credit",
                },
              ],
              hoursEntries: [
                {
                  id: 2,
                  branchId: 2,
                  dayOfWeek: "Monday",
                  location: "DriveThru",
                  hours: "9:00 am to 5:00 pm EST",
                },
                {
                  id: 3,
                  branchId: 2,
                  dayOfWeek: "Tuesday",
                  location: "DriveThru",
                  hours: "9:00 am to 5:00 pm EST",
                },
                {
                  id: 4,
                  branchId: 2,
                  dayOfWeek: "Thursday",
                  location: "DriveThru",
                  hours: "9:00 am to 5:00 pm EST",
                },
                {
                  id: 5,
                  branchId: 2,
                  dayOfWeek: "Friday",
                  location: "DriveThru",
                  hours: "9:00 am to 5:00 pm EST",
                },
                {
                  id: 6,
                  branchId: 2,
                  dayOfWeek: "Saturday",
                  location: "DriveThru",
                  hours: "Closed",
                },
                {
                  id: 7,
                  branchId: 2,
                  dayOfWeek: "Sunday",
                  location: "DriveThru",
                  hours: "Closed",
                },
                {
                  id: 11,
                  branchId: 2,
                  dayOfWeek: "Sunday",
                  location: "Lobby",
                  hours: "Closed",
                },
                {
                  id: 23,
                  branchId: 2,
                  dayOfWeek: "Saturday",
                  location: "Lobby",
                  hours: "Closed",
                },
                {
                  id: 24,
                  branchId: 2,
                  dayOfWeek: "Wednesday",
                  location: "DriveThru",
                  hours: "9:00 am to 5:00 pm EST",
                },
                {
                  id: 25,
                  branchId: 2,
                  dayOfWeek: "Thursday",
                  location: "Lobby",
                  hours: "9:00 am to 5:00 pm EST",
                },
                {
                  id: 36,
                  branchId: 2,
                  dayOfWeek: "Friday",
                  location: "Lobby",
                  hours: "9:00 am to 5:00 pm EST",
                },
                {
                  id: 39,
                  branchId: 2,
                  dayOfWeek: "Wednesday",
                  location: "Lobby",
                  hours: "9:00 am to 5:00 pm EST",
                },
                {
                  id: 40,
                  branchId: 2,
                  dayOfWeek: "Tuesday",
                  location: "Lobby",
                  hours: "9:00 am to 5:00 pm EST",
                },
                {
                  id: 41,
                  branchId: 2,
                  dayOfWeek: "Monday",
                  location: "Lobby",
                  hours: "9:00 am to 5:00 pm EST",
                },
              ],
              branchLinks: [],
            },
            {
              id: 3,
              address: "12345 Fast Lane Hwy",
              extraAddress: "Suite C",
              city: "Detroit",
              state: "MI",
              zipCode: "48083",
              locationNote: "Located by Mardigian Library",
              title: "Third Detroit Branch",
              phone: "(248) 555-5551",
              fax: "",
              email: "thirdbranch@mahalo.com",
              hasLobby: true,
              hasDriveThru: false,
              serviceEntries: [
                {
                  id: 6,
                  branchId: 3,
                  description: "Student Loans",
                  meta: "New or Consolidation loans",
                },
                {
                  id: 7,
                  branchId: 3,
                  description: "ATM",
                  meta: "Deposits, Check Cashing, Cash Withdrawal",
                },
              ],
              hoursEntries: [
                {
                  id: 8,
                  branchId: 3,
                  dayOfWeek: "Monday",
                  location: "Lobby",
                  hours: "8:00 am to 7:30 pm EST",
                },
                {
                  id: 9,
                  branchId: 3,
                  dayOfWeek: "Tuesday",
                  location: "Lobby",
                  hours: "8:00 am to 7:30 pm EST",
                },
                {
                  id: 10,
                  branchId: 3,
                  dayOfWeek: "Wednesday",
                  location: "Lobby",
                  hours: "8:00 am to 7:30 pm EST",
                },
                {
                  id: 12,
                  branchId: 3,
                  dayOfWeek: "Thursday",
                  location: "Lobby",
                  hours: "8:00 am to 7:30 pm EST",
                },
                {
                  id: 13,
                  branchId: 3,
                  dayOfWeek: "Saturday",
                  location: "Lobby",
                  hours: "8:00 am to 11:00 am EST",
                },
                {
                  id: 14,
                  branchId: 3,
                  dayOfWeek: "Sunday",
                  location: "Lobby",
                  hours: "8:00 am to 11:00 am EST",
                },
                {
                  id: 22,
                  branchId: 3,
                  dayOfWeek: "Friday",
                  location: "Lobby",
                  hours: "8:00 am to 7:30 pm EST",
                },
              ],
              branchLinks: [],
            },
            {
              id: 4,
              address: "12345 Fast Lane Hwy",
              extraAddress: "",
              city: "Detroit",
              state: "MI",
              zipCode: "48083",
              locationNote: "2nd Floor, Dunbar building. Southwest campus",
              title: "Fourth Detroit Branch",
              phone: "(248) 555-5551",
              fax: "",
              email: "fourthbranch@mahalo.com",
              hasLobby: true,
              hasDriveThru: false,
              serviceEntries: [
                {
                  id: 2,
                  branchId: 4,
                  description: "Instant Issue Debit Cards",
                  meta: "Cards printed in 10 minutes",
                },
                {
                  id: 3,
                  branchId: 4,
                  description: "Student Loans",
                  meta: "New or Consolidation loans",
                },
                {
                  id: 13,
                  branchId: 4,
                  description: "Financial Advisor",
                  meta: "Free Consultation, no commitment",
                },
              ],
              hoursEntries: [
                {
                  id: 15,
                  branchId: 4,
                  dayOfWeek: "Monday",
                  location: "Lobby",
                  hours: "8:00 am to 7:30 pm EST",
                },
                {
                  id: 16,
                  branchId: 4,
                  dayOfWeek: "Tuesday",
                  location: "Lobby",
                  hours: "8:00 am to 7:30 pm EST",
                },
                {
                  id: 17,
                  branchId: 4,
                  dayOfWeek: "Wednesday",
                  location: "Lobby",
                  hours: "8:00 am to 7:30 pm EST",
                },
                {
                  id: 18,
                  branchId: 4,
                  dayOfWeek: "Thursday",
                  location: "Lobby",
                  hours: "8:00 am to 7:30 pm EST",
                },
                {
                  id: 19,
                  branchId: 4,
                  dayOfWeek: "Friday",
                  location: "Lobby",
                  hours: "8:00 am to 7:30 pm EST",
                },
                {
                  id: 20,
                  branchId: 4,
                  dayOfWeek: "Saturday",
                  location: "Lobby",
                  hours: "8:00 am to 11:00 am EST",
                },
                {
                  id: 21,
                  branchId: 4,
                  dayOfWeek: "Sunday",
                  location: "Lobby",
                  hours: "8:00 am to 11:00 am EST",
                },
              ],
              branchLinks: [],
            },
          ],
          holidaySettings: {
            holidays: [
              {
                id: 1,
                description: "New Year's Day",
                holidayDate: "2020-01-01T00:00:00+00:00",
              },
              {
                id: 2,
                description: "New Year's Day",
                holidayDate: "2021-01-01T00:00:00+00:00",
              },
              {
                id: 3,
                description: "New Year's Day",
                holidayDate: "2021-12-31T00:00:00+00:00",
              },
              {
                id: 4,
                description: "New Year's Day",
                holidayDate: "2023-01-02T00:00:00+00:00",
              },
              {
                id: 5,
                description: "New Year's Day",
                holidayDate: "2024-01-01T00:00:00+00:00",
              },
              {
                id: 6,
                description: "New Year's Day",
                holidayDate: "2025-01-01T00:00:00+00:00",
              },
              {
                id: 7,
                description: "New Year's Day",
                holidayDate: "2026-01-01T00:00:00+00:00",
              },
              {
                id: 8,
                description: "New Year's Day",
                holidayDate: "2027-01-01T00:00:00+00:00",
              },
              {
                id: 9,
                description: "New Year's Day",
                holidayDate: "2027-12-31T00:00:00+00:00",
              },
              {
                id: 10,
                description: "New Year's Day",
                holidayDate: "2029-01-01T00:00:00+00:00",
              },
              {
                id: 11,
                description: "New Year's Day",
                holidayDate: "2030-01-01T00:00:00+00:00",
              },
              {
                id: 12,
                description: "Martin Luther King Jr. Day",
                holidayDate: "2020-01-20T00:00:00+00:00",
              },
              {
                id: 13,
                description: "Martin Luther King Jr. Day",
                holidayDate: "2021-01-18T00:00:00+00:00",
              },
              {
                id: 14,
                description: "Martin Luther King Jr. Day",
                holidayDate: "2022-01-17T00:00:00+00:00",
              },
              {
                id: 15,
                description: "Martin Luther King Jr. Day",
                holidayDate: "2023-01-16T00:00:00+00:00",
              },
              {
                id: 16,
                description: "Martin Luther King Jr. Day",
                holidayDate: "2024-01-15T00:00:00+00:00",
              },
              {
                id: 17,
                description: "Martin Luther King Jr. Day",
                holidayDate: "2025-01-20T00:00:00+00:00",
              },
              {
                id: 18,
                description: "Martin Luther King Jr. Day",
                holidayDate: "2026-01-19T00:00:00+00:00",
              },
              {
                id: 19,
                description: "Martin Luther King Jr. Day",
                holidayDate: "2027-01-18T00:00:00+00:00",
              },
              {
                id: 20,
                description: "Martin Luther King Jr. Day",
                holidayDate: "2028-01-17T00:00:00+00:00",
              },
              {
                id: 21,
                description: "Martin Luther King Jr. Day",
                holidayDate: "2029-01-15T00:00:00+00:00",
              },
              {
                id: 22,
                description: "Martin Luther King Jr. Day",
                holidayDate: "2030-01-21T00:00:00+00:00",
              },
              {
                id: 23,
                description: "Presidents' Day",
                holidayDate: "2020-02-17T00:00:00+00:00",
              },
              {
                id: 24,
                description: "Presidents' Day",
                holidayDate: "2021-02-15T00:00:00+00:00",
              },
              {
                id: 25,
                description: "Presidents' Day",
                holidayDate: "2022-02-21T00:00:00+00:00",
              },
              {
                id: 26,
                description: "Presidents' Day",
                holidayDate: "2023-02-20T00:00:00+00:00",
              },
              {
                id: 27,
                description: "Presidents' Day",
                holidayDate: "2024-02-19T00:00:00+00:00",
              },
              {
                id: 28,
                description: "Presidents' Day",
                holidayDate: "2025-02-17T00:00:00+00:00",
              },
              {
                id: 29,
                description: "Presidents' Day",
                holidayDate: "2026-02-16T00:00:00+00:00",
              },
              {
                id: 30,
                description: "Presidents' Day",
                holidayDate: "2027-02-15T00:00:00+00:00",
              },
              {
                id: 31,
                description: "Presidents' Day",
                holidayDate: "2028-02-21T00:00:00+00:00",
              },
              {
                id: 32,
                description: "Presidents' Day",
                holidayDate: "2029-02-19T00:00:00+00:00",
              },
              {
                id: 33,
                description: "Presidents' Day",
                holidayDate: "2030-02-18T00:00:00+00:00",
              },
              {
                id: 34,
                description: "Memorial Day",
                holidayDate: "2020-05-25T00:00:00+00:00",
              },
              {
                id: 35,
                description: "Memorial Day",
                holidayDate: "2021-05-31T00:00:00+00:00",
              },
              {
                id: 36,
                description: "Memorial Day",
                holidayDate: "2022-05-30T00:00:00+00:00",
              },
              {
                id: 37,
                description: "Memorial Day",
                holidayDate: "2023-05-29T00:00:00+00:00",
              },
              {
                id: 38,
                description: "Memorial Day",
                holidayDate: "2024-05-27T00:00:00+00:00",
              },
              {
                id: 39,
                description: "Memorial Day",
                holidayDate: "2025-05-26T00:00:00+00:00",
              },
              {
                id: 40,
                description: "Memorial Day",
                holidayDate: "2026-05-25T00:00:00+00:00",
              },
              {
                id: 41,
                description: "Memorial Day",
                holidayDate: "2027-05-31T00:00:00+00:00",
              },
              {
                id: 42,
                description: "Memorial Day",
                holidayDate: "2028-05-29T00:00:00+00:00",
              },
              {
                id: 43,
                description: "Memorial Day",
                holidayDate: "2029-05-28T00:00:00+00:00",
              },
              {
                id: 44,
                description: "Memorial Day",
                holidayDate: "2030-05-27T00:00:00+00:00",
              },
              {
                id: 45,
                description: "Independence Day",
                holidayDate: "2020-07-03T00:00:00+00:00",
              },
              {
                id: 46,
                description: "Independence Day",
                holidayDate: "2021-07-05T00:00:00+00:00",
              },
              {
                id: 47,
                description: "Independence Day",
                holidayDate: "2022-07-04T00:00:00+00:00",
              },
              {
                id: 48,
                description: "Independence Day",
                holidayDate: "2023-07-04T00:00:00+00:00",
              },
              {
                id: 49,
                description: "Independence Day",
                holidayDate: "2024-07-04T00:00:00+00:00",
              },
              {
                id: 50,
                description: "Independence Day",
                holidayDate: "2025-07-04T00:00:00+00:00",
              },
              {
                id: 51,
                description: "Independence Day",
                holidayDate: "2026-07-03T00:00:00+00:00",
              },
              {
                id: 52,
                description: "Independence Day",
                holidayDate: "2027-07-05T00:00:00+00:00",
              },
              {
                id: 53,
                description: "Independence Day",
                holidayDate: "2028-07-04T00:00:00+00:00",
              },
              {
                id: 54,
                description: "Independence Day",
                holidayDate: "2029-07-04T00:00:00+00:00",
              },
              {
                id: 55,
                description: "Independence Day",
                holidayDate: "2030-07-04T00:00:00+00:00",
              },
              {
                id: 56,
                description: "Labor Day",
                holidayDate: "2020-09-07T00:00:00+00:00",
              },
              {
                id: 57,
                description: "Labor Day",
                holidayDate: "2021-09-06T00:00:00+00:00",
              },
              {
                id: 58,
                description: "Labor Day",
                holidayDate: "2022-09-05T00:00:00+00:00",
              },
              {
                id: 59,
                description: "Labor Day",
                holidayDate: "2023-09-04T00:00:00+00:00",
              },
              {
                id: 60,
                description: "Labor Day",
                holidayDate: "2024-09-02T00:00:00+00:00",
              },
              {
                id: 61,
                description: "Labor Day",
                holidayDate: "2025-09-01T00:00:00+00:00",
              },
              {
                id: 62,
                description: "Labor Day",
                holidayDate: "2026-09-07T00:00:00+00:00",
              },
              {
                id: 63,
                description: "Labor Day",
                holidayDate: "2027-09-06T00:00:00+00:00",
              },
              {
                id: 64,
                description: "Labor Day",
                holidayDate: "2028-09-04T00:00:00+00:00",
              },
              {
                id: 65,
                description: "Labor Day",
                holidayDate: "2029-09-03T00:00:00+00:00",
              },
              {
                id: 66,
                description: "Labor Day",
                holidayDate: "2030-09-02T00:00:00+00:00",
              },
              {
                id: 67,
                description: "Columbus Day",
                holidayDate: "2020-10-12T00:00:00+00:00",
              },
              {
                id: 68,
                description: "Columbus Day",
                holidayDate: "2021-10-11T00:00:00+00:00",
              },
              {
                id: 69,
                description: "Columbus Day",
                holidayDate: "2022-10-10T00:00:00+00:00",
              },
              {
                id: 70,
                description: "Columbus Day",
                holidayDate: "2023-10-09T00:00:00+00:00",
              },
              {
                id: 71,
                description: "Columbus Day",
                holidayDate: "2024-10-14T00:00:00+00:00",
              },
              {
                id: 72,
                description: "Columbus Day",
                holidayDate: "2025-10-13T00:00:00+00:00",
              },
              {
                id: 73,
                description: "Columbus Day",
                holidayDate: "2026-10-12T00:00:00+00:00",
              },
              {
                id: 74,
                description: "Columbus Day",
                holidayDate: "2027-10-11T00:00:00+00:00",
              },
              {
                id: 75,
                description: "Columbus Day",
                holidayDate: "2028-10-09T00:00:00+00:00",
              },
              {
                id: 76,
                description: "Columbus Day",
                holidayDate: "2029-10-08T00:00:00+00:00",
              },
              {
                id: 77,
                description: "Columbus Day",
                holidayDate: "2030-10-14T00:00:00+00:00",
              },
              {
                id: 78,
                description: "Veterans Day",
                holidayDate: "2020-11-11T00:00:00+00:00",
              },
              {
                id: 79,
                description: "Veterans Day",
                holidayDate: "2021-11-11T00:00:00+00:00",
              },
              {
                id: 80,
                description: "Veterans Day",
                holidayDate: "2022-11-11T00:00:00+00:00",
              },
              {
                id: 81,
                description: "Veterans Day",
                holidayDate: "2023-11-10T00:00:00+00:00",
              },
              {
                id: 82,
                description: "Veterans Day",
                holidayDate: "2024-11-11T00:00:00+00:00",
              },
              {
                id: 83,
                description: "Veterans Day",
                holidayDate: "2025-11-11T00:00:00+00:00",
              },
              {
                id: 84,
                description: "Veterans Day",
                holidayDate: "2026-11-11T00:00:00+00:00",
              },
              {
                id: 85,
                description: "Veterans Day",
                holidayDate: "2027-11-11T00:00:00+00:00",
              },
              {
                id: 86,
                description: "Veterans Day",
                holidayDate: "2028-11-10T00:00:00+00:00",
              },
              {
                id: 87,
                description: "Veterans Day",
                holidayDate: "2029-11-12T00:00:00+00:00",
              },
              {
                id: 88,
                description: "Veterans Day",
                holidayDate: "2030-11-11T00:00:00+00:00",
              },
              {
                id: 89,
                description: "Thanksgiving Day",
                holidayDate: "2020-11-26T00:00:00+00:00",
              },
              {
                id: 90,
                description: "Thanksgiving Day",
                holidayDate: "2021-11-25T00:00:00+00:00",
              },
              {
                id: 91,
                description: "Thanksgiving Day",
                holidayDate: "2022-11-24T00:00:00+00:00",
              },
              {
                id: 92,
                description: "Thanksgiving Day",
                holidayDate: "2023-11-23T00:00:00+00:00",
              },
              {
                id: 93,
                description: "Thanksgiving Day",
                holidayDate: "2024-11-28T00:00:00+00:00",
              },
              {
                id: 94,
                description: "Thanksgiving Day",
                holidayDate: "2025-11-27T00:00:00+00:00",
              },
              {
                id: 95,
                description: "Thanksgiving Day",
                holidayDate: "2026-11-26T00:00:00+00:00",
              },
              {
                id: 96,
                description: "Thanksgiving Day",
                holidayDate: "2027-11-25T00:00:00+00:00",
              },
              {
                id: 97,
                description: "Thanksgiving Day",
                holidayDate: "2028-11-23T00:00:00+00:00",
              },
              {
                id: 98,
                description: "Thanksgiving Day",
                holidayDate: "2029-11-22T00:00:00+00:00",
              },
              {
                id: 99,
                description: "Thanksgiving Day",
                holidayDate: "2030-11-28T00:00:00+00:00",
              },
              {
                id: 100,
                description: "Christmas Day",
                holidayDate: "2020-12-25T00:00:00+00:00",
              },
              {
                id: 101,
                description: "Christmas Day",
                holidayDate: "2021-12-24T00:00:00+00:00",
              },
              {
                id: 102,
                description: "Christmas Day",
                holidayDate: "2022-12-26T00:00:00+00:00",
              },
              {
                id: 103,
                description: "Christmas Day",
                holidayDate: "2023-12-25T00:00:00+00:00",
              },
              {
                id: 104,
                description: "Christmas Day",
                holidayDate: "2024-12-25T00:00:00+00:00",
              },
              {
                id: 105,
                description: "Christmas Day",
                holidayDate: "2025-12-25T00:00:00+00:00",
              },
              {
                id: 106,
                description: "Christmas Day",
                holidayDate: "2026-12-25T00:00:00+00:00",
              },
              {
                id: 107,
                description: "Christmas Day",
                holidayDate: "2027-12-24T00:00:00+00:00",
              },
              {
                id: 108,
                description: "Christmas Day",
                holidayDate: "2028-12-25T00:00:00+00:00",
              },
              {
                id: 109,
                description: "Christmas Day",
                holidayDate: "2029-12-25T00:00:00+00:00",
              },
              {
                id: 110,
                description: "Christmas Day",
                holidayDate: "2030-12-25T00:00:00+00:00",
              },
              {
                id: 111,
                description: "Juneteenth",
                holidayDate: "2024-06-19T00:00:00+00:00",
              },
              {
                id: 112,
                description: "Juneteenth",
                holidayDate: "2025-06-19T00:00:00+00:00",
              },
              {
                id: 113,
                description: "Juneteenth",
                holidayDate: "2026-06-19T00:00:00+00:00",
              },
              {
                id: 114,
                description: "Juneteenth",
                holidayDate: "2027-06-18T00:00:00+00:00",
              },
              {
                id: 115,
                description: "Juneteenth",
                holidayDate: "2028-06-19T00:00:00+00:00",
              },
              {
                id: 116,
                description: "Juneteenth",
                holidayDate: "2029-06-19T00:00:00+00:00",
              },
              {
                id: 117,
                description: "Juneteenth",
                holidayDate: "2030-06-19T00:00:00+00:00",
              },
            ],
          },
          contactNumbers: [],
          createAtUtc: "2023-07-11T14:01:47.8310461+00:00",
          changeAtUtc: "2025-06-25T16:00:26.7517401+00:00",
        }),
      },
      displayIdentifier: "Mahalo: Search Bot",
      harnessFolder:
        "https://drive.google.com/drive/folders/1xSkMOZlAVs2TEhxRWr4DemYFb0qTGrNe?usp=sharing",
      botId: "4bd1e007-82d6-489b-b750-3cffd26ce32c",
      botName: "Banking Support",
      composerPlaceholder: "How can we help?",
      botDescription: "Mahalo AI Assistant",
      title: "Mahalo",
    },
    {
      clientId: "f8e353fd-315d-4390-8a40-fb85861002b7",
      languageCodes: [{ name: "English (US)", languageCode: "en-us" }],
      userData: { firstName: "TestName", languageCode: "en-us" },
      displayIdentifier: "Company-bot",
      harnessFolder: "",
      botId: "guid",
      botName: "Fi",
      composerPlaceholder: "What's on your mind?",
      botAvatar: `https://omni-public-media.s3.us-west-2.amazonaws.com/branding/kindly_human/Fi.png`,
      botDescription: "Digital Concierge",
      title: "Kindly Human Concierge",
    },
    {
      clientId: "4263b639-6b04-49b6-a8ea-913c048bb4cc",
      languageCodes: [{ name: "English (US)", languageCode: "en-us" }],
      userData: { firstName: "TestName", languageCode: "en-us" },
      displayIdentifier: "Company-bot",
      harnessFolder: "",
      botId: "guid",
      botName: "Peersona",
      composerPlaceholder: "What's on your mind?",
      botDescription: "Confidential Confidant",
      title: "Kindly Human Peersona",
    },
    {
      clientId: "056e786b-b97a-4804-acc7-b4ede953bd3a",
      languageCodes: [{ name: "English (US)", languageCode: "en-us" }],
      userData: { firstName: "TestName", languageCode: "en-us" },
      displayIdentifier: "Company-bot",
      harnessFolder: "",
      botId: "guid",
      botName: "Simple Search",
      composerPlaceholder: "Enter Query",
      botDescription: "Search Assistant",
      title: "Simple Search",
    },
    {
      clientId: "1d9c1910-60da-4fa2-a237-89fd3122b711",
      languageCodes: [{ name: "English (US)", languageCode: "en-us" }],
      userData: { firstName: "TestName", languageCode: "en-us" },
      displayIdentifier: "DEMO - Isa Bot",
      harnessFolder: "",
      botId: "890e9bb6-b2c1-4a3d-ae81-c967f3c8c70f",
      botName: "Isa Bot",
      composerPlaceholder: "Ask me anything!",
      botDescription: "Sports Celebrity Emulation",
      title: "Celebrity Avatar",
    },
    {
      clientId: "387060e7-5d49-4fdf-b140-2bbd1b5dfd88",
      languageCodes: [{ name: "English (US)", languageCode: "en-us" }],
      userData: { firstName: "TestName", languageCode: "en-us" },
      displayIdentifier: "Visions Demo",
      harnessFolder: "",
      botId: "guid",
      // botId: "03aeb9ee-261e-4471-84b3-b921b6e90482",
      botName: "Visions",
      botAvatar: `https://omni-public-media.s3.us-west-2.amazonaws.com/branding/visionsfcu/visions-cares-logo-white.svg`,
      composerPlaceholder: "How can we help you today?",
      botDescription: "Visions AI Assistant",
      title: "Visions",
    },
    {
      clientId: "a4a35bff-1445-4a94-a544-928b4a38c8aa",
      languageCodes: [
        { name: "English (US)", languageCode: "en-us" },
        { name: "Spanish (US)", languageCode: "es-us" },
        { name: "Russian (RU)", languageCode: "ru-RU" },
        { name: "Swahili (KE)", languageCode: "sw-KE" },
      ],
      userData: { firstName: "TestName", languageCode: "en-us" },
      displayIdentifier: "Park View Federal CU: Penny",
      harnessFolder:
        "https://drive.google.com/drive/folders/1YplU9_V4mdKSzkk1uVw1H6uVP57Fe-0l?usp=sharing",
      botId: "ff935ea6-cadf-4e87-90cf-8cc9af1b2538",
      botName: "Penny",
      composerPlaceholder: "Ask your question here",
      botDescription: "A Financial AI Assistant",
      title: "Park View Federal Credit Union",
    },
    {
      embedCode: "",
      botId: "2dc49223-fc6b-4308-af8c-fdf15a1ca74e",
      clientId: "a53fb74e-6eeb-4bfb-8af8-d7097ef662ef",
      displayIdentifier: "Demo - Walmart Associate Partner",
      botName: "Walmart Associate Partner",
      botAvatar:
        "https://omni-public-media.s3.us-west-2.amazonaws.com/branding/walmart/WMT-SparkYellow-500x500.png",
      composerPlaceholder: "",
      botDescription: `I can assist you with information and guidance related to Walmart outreach and philanthropic initiatives. Let me help you learn more about your benefits and resources.`,
      title: "Walmart Associate Partner",
      userData: { firstName: "TestFirstName", languageCode: "en-us" },
    },
  ];

  if (clientId != null) {
    let filtered = theConfigs.filter(obj => obj.clientId === clientId);

    if (filtered.length > 0) {
      return filtered[0];
    } else {
      return null;
    }
  } else {
    return theConfigs;
  }
};
